module.exports = __webpack_public_path__ + "img/icon_01@2x.a672bb2d.png";